import React, { createContext, useState } from 'react';
import './Chat.scss';
import {chats} from '../../assets/constants/chats.js';
const Chatprovider = createContext();
const Chat = () => {
    const chatclose =()=>{
        const chat = document.querySelector('.chat-section');
        chat.style.display="none";    
}
    return (
        <div className="chat-section" >
           <div className="container">
           <div className="chat-box">
                <span className="close" onClick={chatclose}><i className="material-icons">close</i></span>
                <div className="chat-list">
                    {
                        chats.map(chat=>{
                            return  <div className="chat-item">
                               <div className="person-info">
                               <h4>{chat.person}</h4>
                               <span>{chat.createdAt}</span>
                               </div>
                                <p>
                                   {chat.title}
                                </p>
                            </div>
                           
                        })
                    }
                </div>
           </div>
           </div>
        </div>
    );
}

export default Chat;
